<template>
    <div :id="tableId" class="table-responsive">
        <div v-if="isLoaded">
            <b-card>
                <div class="table-responsive">
                <table class="table table-hover" style="table-layout: fixed; font-size: 0.875em">
                    <thead>
                    <tr>
                        <th>{{ $t('wasteDescription') }}</th>
                        <th>{{ $t('wasteType') }}</th>
                        <th>{{ $t('storage') }}</th> 
                        <th>{{ $t('municipality') }}</th>
                        <th>{{ $t('recovery') }}</th>
                        <th id="waste-form-last-column" style="width: 9em;"></th>
                    </tr>
                    </thead>
                    <tbody>
                        <!-- Update item view -->
                        <tr v-for="item in items" @keyup.enter="updateItem(item)" @keyup.esc="revertChanges(item)" @click="routeTo(item)">
                            <td>
                                <template v-if="!item.editMode">
                                    <div>
                                        {{item.description.value}}
                                    </div>
                                </template>
                                <template v-else>
                                    <b-form-select 
                                        v-model="item.description.editedValue" 
                                        :options="wasteDescriptions" 
                                        @change="setWasteDescriptions($event, item)" style="border-radius: unset !important; height: 100%;"/> 
                                </template>
                            </td>
                            <td>
                                <template v-if="!item.editMode">
                                    <div>
                                        {{item.wasteType.value}}
                                    </div>
                                </template>
                                <template v-else>
                                    <b-form-select 
                                        v-model="item.wasteType.editedValue" 
                                        :options="wasteTypes" 
                                        @change="setWasteTypes($event, item)" style="border-radius: unset !important; height: 100%;"/>
                                </template>
                            </td>
                            <td>
                                <template v-if="!item.editMode">
                                    <div>
                                        {{item.storageType.value}}
                                    </div>
                                </template>
                                <template v-else>
                                    <b-form-select 
                                        v-model="item.storageType.editedValue" 
                                        :options="wasteStorages" 
                                        @change="setWasteStorage($event, item)" style="border-radius: unset !important; height: 100%;"/>
                                </template>   
                            </td>
                            <td>
                                <template v-if="!item.editMode">
                                    <div>
                                        {{item.municipality.value}}
                                    </div>
                                </template>
                                <template v-else>
                                    <b-form-input v-model="item.municipality.editedValue" style="text-align: center" required/>
                                </template>                        
                            </td>
                            <td>
                                <template v-if="!item.editMode">
                                    <div>
                                        {{item.recovery.value}}
                                    </div>
                                </template>
                                <template v-else>
                                    <b-form-input v-model="item.recovery.editedValue" style="text-align: center" required/>
                                </template>  
                            </td>                
                            <td :style="{width: lastColumnWidth}" class="edit-column">
                                <div class="tableBodyCell">
                                    <div v-if="!item.editMode" @click="makeRowEditable(item)" style="color: #8888; cursor: pointer">
                                        <i class="fas fa-edit"></i>
                                    </div>
                                    <div :key="'btngroup'" v-else class="table-button-group">
                                        <b-button v-b-tooltip.hover :title="$t('save')" @click="updateItem(item, fields)"><i class="fas fa-check"></i></b-button>
                                        <b-button v-b-tooltip.hover :title="$t('cancel')" @click="revertChanges(item)"><i class="fas fa-ban"></i></b-button>
                                        <b-button v-b-modal.warn v-b-tooltip.hover :title="$t('delete')" @click="deleteItem($event, item.id)"><i class="fas fa-trash-alt"></i></b-button>
                                    </div>
                                </div>
                            </td>
                        </tr>
                        <transition name="fadere" mode="out-in">
                            <!-- Create item view -->
                            <tr v-if="insertMode" @keyup.enter="createItem(tempItem)" @keyup.esc="cancelNewRow()" style="border-bottom: 1px solid #ddd">
                                <td>
                                    <b-form-select 
                                        v-model="tempItem.description.value" 
                                        :options="wasteDescriptions" 
                                        @change="setWasteDescriptions($event, tempItem)" style="border-radius: unset !important; height: 100%;"/>
                                </td>
                                <td>
                                    <b-form-select 
                                        v-model="tempItem.wasteType.value" 
                                        :options="wasteTypes" 
                                        @change="setWasteTypes($event, tempItem)" style="border-radius: unset !important; height: 100%;"/>
                                </td>
                                <td>
                                    <b-form-select 
                                        v-model="tempItem.storageType.value" 
                                        :options="wasteStorages" 
                                        @change="setWasteStorages($event, tempItem)" style="border-radius: unset !important; height: 100%;"/>
                                </td>
                                <td>
                                    <b-form-input v-model="tempItem.municipality.value" style="text-align: center" :disabled="municipalityDisabled == 1 ? true : false"/>
                                </td>
                                <td>
                                    <b-form-input v-model="tempItem.recovery.value" style="text-align: center" :disabled="recoveryDisabled == 1 ? true : false"/>
                                </td>
                                <td class="edit-column" :style="{width: lastColumnWidth}">
                                    <div class="table-button-group">
                                        <b-button v-b-tooltip.hover :title="$t('save')" @click="createItem(tempItem)" style="mso-border-shadow: no"><i class="fas fa-check"></i></b-button>
                                        <b-button v-b-tooltip.hover :title="$t('cancel')" @click="cancelNewRow()"><i class="fas fa-ban"></i></b-button>
                                    </div>
                                </td>
                            </tr>
                        </transition>
                        <tr v-if="!insertMode && this.$store.state.user.permissions.canEditGoals" @click="insertRow()" class="insert-row">
                            <td :colspan="tableCols.length + 1">
                                <div class="tableBodyCell">
                                    <div>
                                        <i class="fas fa-plus-circle fa-2x"></i>
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
                </div>
            </b-card>
        </div>
        <div v-else></div>
    </div>
</template>

<script>
import uuidV4 from 'uuid/v4';
import moment from 'moment';
import _ from 'lodash';
import CustomForm from './CustomForm';

export default {
    name: 'CustomFormTable',
    props: {
        initialData: {
            type: Object,
            default: () => ({
                items: [],
                fields: []
            })
        },
        routeParams: {
            type: Object,
            default: () => ({
                site_id: null,
                form_type: null
            })
        },
        isEditable: {
            type: Boolean,
            default: () => false
        }
    },
    data() {
        return {
            tempItem: {}, // Temporary object used for inserts
            formSchema: [],
            tableCols: [],
            tableData: [],
            emptyFields: [],
            fields: [], // table headers
            items: [], // includes some info to show on cells
            isLoaded: false, // Toggles page loading,
            municipalityDisabled: 0,
            recoveryDisabled: 0,
            wasteDescriptions: [],
            wasteTypes: [],
            wasteStorages: [],
            formData: {},
            insertMode: false,
            lastColumnWidth: '130px',
            name: null,
            tableId: uuidV4()
        };
    },
    components: {
        CustomForm
    },
    methods: {
        setWasteDescriptions(val, item) {
            item.description.editedValue = val;
            let id = _.find(this.wasteDescriptions, function(o) {
                return o.value === val;
            }).id;
            // this switch sets all table values according to waste description.
            switch (id) {
                case 0:
                    item.wasteType[this.insertMode ? 'value' : 'editedValue'] = _.find(
                        this.wasteTypes,
                        function(o) {
                            return o.id === 0;
                        }
                    ).value;

                    item.storageType[this.insertMode ? 'value' : 'editedValue'] = _.find(
                        this.wasteStorages,
                        function(o) {
                            return o.id === 0;
                        }
                    ).value;
                    this.municipalityDisabled = 0;
                    this.recoveryDisabled = 0;

                    item.municipality[this.insertMode ? 'value' : 'editedValue'] = null;
                    item.recovery[this.insertMode ? 'value' : 'editedValue'] = null;
                    break;
                case 1:
                    item.wasteType[this.insertMode ? 'value' : 'editedValue'] = _.find(
                        this.wasteTypes,
                        function(o) {
                            return o.id === 0;
                        }
                    ).value;

                    item.storageType[this.insertMode ? 'value' : 'editedValue'] = _.find(
                        this.wasteStorages,
                        function(o) {
                            return o.id === 1;
                        }
                    ).value;

                    this.municipalityDisabled = 0;
                    this.recoveryDisabled = 0;

                    item.municipality[this.insertMode ? 'value' : 'editedValue'] = null;
                    item.recovery[this.insertMode ? 'value' : 'editedValue'] = null;
                    break;

                case 2:
                    item.wasteType[this.insertMode ? 'value' : 'editedValue'] = _.find(
                        this.wasteTypes,
                        function(o) {
                            return o.id === 1;
                        }
                    ).value;

                    item.storageType[this.insertMode ? 'value' : 'editedValue'] = _.find(
                        this.wasteStorages,
                        function(o) {
                            return o.id === 2;
                        }
                    ).value;

                    this.municipalityDisabled = 0;
                    this.recoveryDisabled = 1;

                    item.municipality[this.insertMode ? 'value' : 'editedValue'] = null;
                    item.recovery[this.insertMode ? 'value' : 'editedValue'] = '-';
                    break;
                case 3:
                    item.wasteType[this.insertMode ? 'value' : 'editedValue'] = _.find(
                        this.wasteTypes,
                        function(o) {
                            return o.id === 2;
                        }
                    ).value;

                    item.storageType[this.insertMode ? 'value' : 'editedValue'] = _.find(
                        this.wasteStorages,
                        function(o) {
                            return o.id === 3;
                        }
                    ).value;

                    this.municipalityDisabled = 1;
                    this.recoveryDisabled = 0;

                    item.municipality[this.insertMode ? 'value' : 'editedValue'] = '-';
                    item.recovery[this.insertMode ? 'value' : 'editedValue'] =
                        'Belediye/ Sağlık Kuruluşu/ Lisanslı Bertaraf Firması';
                    break;
                case 4:
                    item.wasteType[this.insertMode ? 'value' : 'editedValue'] = _.find(
                        this.wasteTypes,
                        function(o) {
                            return o.id === 3;
                        }
                    ).value;

                    item.storageType[this.insertMode ? 'value' : 'editedValue'] = _.find(
                        this.wasteStorages,
                        function(o) {
                            return o.id === 4;
                        }
                    ).value;

                    this.municipalityDisabled = 1;
                    this.recoveryDisabled = 0;

                    item.municipality[this.insertMode ? 'value' : 'editedValue'] = '-';
                    item.recovery[this.insertMode ? 'value' : 'editedValue'] =
                        'Lisanslı Bertaraf Firması';
                    break;
                case 5:
                    item.wasteType[this.insertMode ? 'value' : 'editedValue'] = _.find(
                        this.wasteTypes,
                        function(o) {
                            return o.id === 3;
                        }
                    ).value;

                    item.storageType[this.insertMode ? 'value' : 'editedValue'] = _.find(
                        this.wasteStorages,
                        function(o) {
                            return o.id === 5;
                        }
                    ).value;

                    this.municipalityDisabled = 1;
                    this.recoveryDisabled = 0;

                    item.municipality[this.insertMode ? 'value' : 'editedValue'] = '-';
                    item.recovery[this.insertMode ? 'value' : 'editedValue'] =
                        'Üretici firma(HP) - Anel Doğa';
                    break;
                case 6:
                    item.wasteType[this.insertMode ? 'value' : 'editedValue'] = _.find(
                        this.wasteTypes,
                        function(o) {
                            return o.id === 3;
                        }
                    ).value;

                    item.storageType[this.insertMode ? 'value' : 'editedValue'] = _.find(
                        this.wasteStorages,
                        function(o) {
                            return o.id === 6;
                        }
                    ).value;

                    this.municipalityDisabled = 1;
                    this.recoveryDisabled = 0;

                    item.municipality[this.insertMode ? 'value' : 'editedValue'] = '-';
                    item.recovery[this.insertMode ? 'value' : 'editedValue'] =
                        'Üretici Firma - TAP';
                    break;
                case 7:
                    item.wasteType[this.insertMode ? 'value' : 'editedValue'] = _.find(
                        this.wasteTypes,
                        function(o) {
                            return o.id === 4;
                        }
                    ).value;

                    item.storageType[this.insertMode ? 'value' : 'editedValue'] = _.find(
                        this.wasteStorages,
                        function(o) {
                            return o.id === 7;
                        }
                    ).value;

                    this.municipalityDisabled = 1;
                    this.recoveryDisabled = 0;

                    item.municipality[this.insertMode ? 'value' : 'editedValue'] = '-';
                    item.recovery[this.insertMode ? 'value' : 'editedValue'] =
                        'Garanti Teknoloji / Lisanslı Geri Dönüşüm Firması';
                    break;
                case 8:
                    item.wasteType[this.insertMode ? 'value' : 'editedValue'] = _.find(
                        this.wasteTypes,
                        function(o) {
                            return o.id === 3;
                        }
                    ).value;

                    item.storageType[this.insertMode ? 'value' : 'editedValue'] = _.find(
                        this.wasteStorages,
                        function(o) {
                            return o.id === 8;
                        }
                    ).value;

                    this.municipalityDisabled = 1;
                    this.recoveryDisabled = 0;

                    item.municipality[this.insertMode ? 'value' : 'editedValue'] = '-';
                    item.recovery[this.insertMode ? 'value' : 'editedValue'] =
                        'Sözleşmeli bakım firmaları';
                    break;
                case 9:
                    item.wasteType[this.insertMode ? 'value' : 'editedValue'] = _.find(
                        this.wasteTypes,
                        function(o) {
                            return o.id === 4;
                        }
                    ).value;

                    item.storageType[this.insertMode ? 'value' : 'editedValue'] = _.find(
                        this.wasteStorages,
                        function(o) {
                            return o.id === 9;
                        }
                    ).value;
                    this.municipalityDisabled = 1;
                    this.recoveryDisabled = 0;

                    item.municipality[this.insertMode ? 'value' : 'editedValue'] = '-';
                    item.recovery[this.insertMode ? 'value' : 'editedValue'] =
                        'Sözleşmeli bakım firmaları';
                    break;
                case 10:
                    item.wasteType[this.insertMode ? 'value' : 'editedValue'] = _.find(
                        this.wasteTypes,
                        function(o) {
                            return o.id === 4;
                        }
                    ).value;

                    item.storageType[this.insertMode ? 'value' : 'editedValue'] = _.find(
                        this.wasteStorages,
                        function(o) {
                            return o.id === 10;
                        }
                    ).value;
                    this.municipalityDisabled = 1;
                    this.recoveryDisabled = 0;

                    item.municipality[this.insertMode ? 'value' : 'editedValue'] = '-';
                    item.recovery[this.insertMode ? 'value' : 'editedValue'] =
                        'Sözleşmeli bakım firmaları';
                    break;
                case 11:
                    item.wasteType[this.insertMode ? 'value' : 'editedValue'] = _.find(
                        this.wasteTypes,
                        function(o) {
                            return o.id === 5;
                        }
                    ).value;

                    item.storageType[this.insertMode ? 'value' : 'editedValue'] = _.find(
                        this.wasteStorages,
                        function(o) {
                            return o.id === 11;
                        }
                    ).value;
                    this.municipalityDisabled = 0;
                    this.recoveryDisabled = 1;

                    item.municipality[this.insertMode ? 'value' : 'editedValue'] = null;
                    item.recovery[this.insertMode ? 'value' : 'editedValue'] = '-';
                    break;
            }
            if (this.insertMode) {
                this.tempItem = item;
            }
        },
        setWasteTypes(val, item) {
            item.wasteType.value = val;
        },
        setWasteStorages(val, item) {
            item.storageType.value = val;
        },
        onformChange(formData) {
            this.formData = formData;
        },
        // Revert any changes made on an item
        revertChanges(item) {
            this.fields.forEach(field => {
                if (field.editable) {
                    if (field.type === 'date') {
                        item[field.key].editedValue = moment(item[field.key].value).toDate();
                        // TODO: Make this work for currencies other than Turkish
                        // Also put it in its own function
                    } else if (field.type === 'daterange') {
                        item[field.key].editedValue = [
                            moment(item[field.key].value[0]).toDate(),
                            moment(item[field.key].value[1]).toDate()
                        ];
                    } else if (field.type === 'number') {
                        item[field.key].editedValue = item[field.key].value;
                    } else if (field.type === 'float' || field.type === 'number') {
                        item[field.key].editedValue = this.convertToLocalizedFloat(
                            item[field.key].value,
                            this.locale
                        );
                    } else if (field.type === 'file') {
                        item[field.key].editedFileId = item[field.key].fileId;
                    } else {
                        item[field.key].editedValue = item[field.key].value;
                    }
                }
            });
            item.editMode = false;
        },
        insertRow() {
            this.insertMode = true;
            this.items.forEach(item => {
                item.editMode = false;
            });
            this.bindTempItemToView();
        },
        cancelNewRow() {
            this.insertMode = false;
            this.bindTempItemToView();
        },
        makeRowEditable(item) {
            this.items.forEach(this.revertChanges);
            this.insertMode = false;
            item.editMode = true;
        },
        bindTempItemToView() {
            this.tempItem = {};
            this.fields.forEach(field => {
                if (field.editable) {
                    if (field.type === 'file') {
                        this.$set(this.tempItem, field.key, {
                            filename: null,
                            fileUrl: null,
                            fileId: null
                        });
                    } else {
                        let defaultValue = null;
                        if (field.type === 'date' || field.type === 'daterange') {
                            defaultValue = this.setDefaultDateTypedValue(field.type, field.key);
                        } else if (field.type === 'select') {
                            defaultValue = this.setDefaultSelectTypedValue(field.key);
                        }
                        this.$set(this.tempItem, field.key, {
                            value: field.type === 'select' ? defaultValue : null,
                            defaultValue,
                            classes: {
                                'form-control': field.type !== 'date' && field.type !== 'daterange',
                                'is-invalid': false
                            },
                            hasWarn: false,
                            required: field.required
                        });
                    }
                }
            });
        },
        // Insert new item
        createItem(item) {
            if(!_.isNull(item.description.value) && !_.isNull(item.description.storageType) && !_.isNull(item.description.wasteType)){
                this.$emit('insertItem', item, data => {
                    this.insertMode = false;
                    this.items.push(this.prepareItem(data));
                    this.bindTempItemToView();
                    this.calculateLastColumnWidth();
                });
            }else{
                this.showErrorNotification(this.$t('wasteDescriptionEmptyError'));
            }
        },
        updateItem(item, fields) {
            this.$emit('applyDataChanges', item, fields, data => {
                let updatedItem = this.prepareItem(data);
                for (let key in item) {
                    item[key] = updatedItem[key];
                }
                item.editMode = false;
            });
        },

        // Delete an item
        deleteItem($event, id) {
            this.showWarnModal($event.target);
            this.$eventHub.$on(this.$store.state.modal.eventId, () => {
                this.$emit('deleteItemById', id);
                this.items = this.items.filter(item => {
                    return item.id !== id;
                });
            });
        },
        // Prepare a dataType object to use in dom
        prepareItem(row) {
            let generated = {};
            for (let key in row) {
                let foundField = _.find(this.fields, {key: key});
                if (foundField) {
                    generated[key] = {
                        value: row[key]
                    };
                    if (this.isEditable) {
                        if (foundField.type === 'daterange') {
                            generated[key].editedValue = [
                                moment(generated[key].value[0]).toDate(),
                                moment(generated[key].value[1]).toDate()
                            ];
                            // TODO: Make this work for currencies other than Turkish
                            // Also put it in its own function
                        } else if (foundField.type === 'date') {
                            generated[key].editedValue = moment(generated[key].value).toDate();
                        } else if (foundField.type === 'number') {
                            generated[key].editedValue = generated[key].value;
                        } else if (foundField.type === 'float' || foundField.type === 'number') {
                            generated[key].value = generated[key].value.toFixed(2);
                            generated[key].editedValue = this.convertToLocalizedFloat(
                                generated[key].value,
                                this.locale
                            );
                        } else if (foundField.type === 'link') {
                            generated[key].editedValue = generated[key].value;
                        } else if (foundField.type === 'file') {
                            generated[key].fileId = row[key].fileId;
                            generated[key].editedFileId = generated[key].fileId;
                            generated[key].fileUrl = row[key].fileUrl;
                            generated[key].editedFileUrl = generated[key].fileUrl;
                            generated[key].filename = row[key].filename;
                            generated[key].editedFilename = generated[key].filename;
                        } else if (foundField.type === 'select') {
                            generated[key].editedValue = generated[key].value;
                        } else {
                            generated[key].editedValue = generated[key].value;
                        }

                        /*generated[key].classes = {
                            'form-control':
                                foundField.type !== 'date' && foundField.type !== 'daterange',
                            'is-invalid': false
                        };
                        generated[key].hasWarn = false;
                        generated[key].required = foundField.required;
                        */
                    }
                }
            }

            generated.editMode = false;
            generated.id = row.id;
            generated.path = row.path;

            return generated;
        },

        fetchDesign() {
            this.tableCols = this.initialData.fields;
            this.tableData = this.initialData.items;
            return this.initialData;
        },
        routeTo(item) {
            if (!this.isEditable) {
                this.$router.push({path: item.path});
            }
        },
        calculateLastColumnWidth() {
            return this.$nextTick().then(() => {
                let element = document.getElementById('waste-form-last-column');
                if (element) {
                    this.lastColumnWidth = element.offsetWidth + 'px';
                }
                return true;
            });
        },
        init(items = [], fields = []) {
            this.fields = fields;
            this.items = items.map(this.prepareItem);
            this.isLoaded = false;
            let filteredData = _.map(this.initialData.fields, 'data');
            for (let i = 0; i < 3; i++) {
                let tempId = 0;
                filteredData[i].forEach(element => {
                    let tempObject = {};
                    if (i == 0) {
                        tempObject.id = tempId;
                        tempObject.value = element;
                        tempObject.text = element;
                        this.wasteDescriptions.push(tempObject);
                        tempId++;
                    } else if (i == 1) {
                        tempObject.id = tempId;
                        tempObject.value = element;
                        tempObject.text = element;
                        this.wasteTypes.push(tempObject);
                        tempId++;
                    } else if (i == 2) {
                        tempObject.id = tempId;
                        tempObject.value = element;
                        tempObject.text = element;
                        this.wasteStorages.push(tempObject);
                        tempId++;
                    }
                });
            }
            this.wasteDescriptions = _.uniqBy(this.wasteDescriptions, 'id');
            this.wasteTypes = _.uniqBy(this.wasteTypes, 'id');
            this.wasteStorages = _.uniqBy(this.wasteStorages, 'id');
            this.fetchDesign();
            this.isLoaded = true;
        }
    },
    watch: {
        initialData(newVal = {}) {
            this.init(_.cloneDeep(newVal.items), _.cloneDeep(newVal.fields));
        }
    },
    created() {
        window.addEventListener('resize', this.calculateLastColumnWidth);
        this.init(_.cloneDeep(this.initialData.items), _.cloneDeep(this.initialData.fields));
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.calculateLastColumnWidth);
    }
};
</script>

<style scoped>
</style>

<i18n src="../i18n/common.json"></i18n>

<i18n>
    {
    "tr": {
    "wasteDescription": "Atık Tanımı",
    "wasteType": "Atığın Tipi/Cinsi",
    "storage": "Depolama Şekli/Yeri",
    "municipality": "İlgili Belediye",
    "recovery": "Geri Dönüşüm",
    "wasteDescriptionEmptyError": "Atık tanımı boş bırakılamaz."
    },
    "en": {
    "wasteDescription": "Waste Description",
    "wasteType": "Waste Type",
    "storage": "Storage",
    "municipality": "Municipality",
    "recovery": "Recovery",
    "wasteDescriptionEmptyError": "Atık tanımı can't be emtpy."
    }
    }
</i18n>



// WEBPACK FOOTER //
// src/components/CustomFormTable.vue